import classNames from 'classnames';
import { YoutubeVideo } from '@sapientpro/sapientpro-data-models';
import styles from './YoutubeVideoSection.module.scss';
import ArticleVideo from '../../page-components/Blog/Article/ArticleVideo';

const YoutubeVideoSection = ({ data }: { data: YoutubeVideo }) => (
  <section className={classNames(styles.videoSection, 'container')}>
    <ArticleVideo
      videoId={data.videoId}
      videoDescription={data.description}
    />
  </section>
);

export default YoutubeVideoSection;
